// extracted by mini-css-extract-plugin
export default {"fallback__image":"fallback__image--3ht-l","fallbackImage":"fallback__image--3ht-l"};